<template>
    <div class="dashboard-window" v-if="data && chartData">
        <div class="dashboard-window-header">
            <div class="window-header__title">
                Выручка по часам
            </div>
        </div>

        <div class="dashboard-window-body">
            <div class="dashboard-window-body-item">
                <Line
                    :options="chartSettings"
                    :data="chartData"
                />
                <div class="tooltips">
                    <!-- <span>
                        <div class="circle plan"></div>
                        план
                    </span> -->
                    <span>
                        <div class="circle revenue"></div>
                        выручка
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { formatNumber } from '@/utils/numberFormat'
import { Line } from 'vue-chartjs'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
    Filler
} from 'chart.js'

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
    Filler
)

export default {
    props: {
        data: {
            type: Object,
            default: null
        }
    },

    components: {
        Line
    },

    data() {
        return {
            chartData: null,

            chartSettings: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        callbacks: {
                            label: (context) => {
                                return `${context.dataset.label}: ${this.formatNumber(context.raw)} ₽`
                            }
                        }
                    }
                },
                scales: {
                    x: {
                        grid: {
                            display: false
                        },
                        ticks: {
                            color: '#888'
                        }
                    },
                    y: {
                        grid: {
                            color: '#eee'
                        },
                        ticks: {
                            color: '#888',
                            callback: (value) => this.formatNumber(value)
                        }
                    }
                }
            }
        }
    },

    methods: {
        formatNumber,

        initChart() {
            if (!this.data) return

            const labels = []
            const revenue = []

            const sorted = Object.entries(this.data)
                .sort((a, b) => Number(a[0]) - Number(b[0]))

            sorted.forEach(([hour, value]) => {
                labels.push(hour)
                revenue.push(value)
            })

            const plan = revenue.map(v => v * 1.15)

            this.chartData = {
                labels,
                datasets: [
                    {
                        type: 'bar',
                        label: 'Выручка',
                        data: plan,
                        backgroundColor: '#B8E6FF',
                        borderRadius: 0,
                        borderSkipped: false,
                        order: 10
                    },
                    // {
                    //     type: 'line',
                    //     label: 'Выручка',
                    //     data: revenue,
                    //     borderColor: '#E5A400',
                    //     backgroundColor: 'rgba(242, 178, 14, 0.1)',
                    //     fill: {
                    //         target: 'origin'
                    //     },
                    //     tension: 0.4,
                    //     pointRadius: 0,
                    //     borderWidth: 2,
                    //     order: 1,
                    //     yAxisID: 'y'
                    // }
                ]
            }
        }

    },

    watch: {
        data: {
            handler() {
                this.initChart()
            },
            deep: true,
            immediate: true
        }
    }
}
</script>

<style scoped lang="scss">
.dashboard-window {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    height: 320px;
    font-family: 'SFProDisplay', sans-serif;
    background: var(--color-white);
    border-radius: 16px;
    border: 1px solid #F5F5F5;
    overflow: hidden;

    &-header {
        font-size: 16px;
        font-weight: 700;
    }

    &-body {
        position: relative;
        &-item {
            & canvas {
                height: 224px !important;
            }
            & .tooltips {
                display: flex;
                align-items: center;
                gap: 16px;
                color: #737373;
                & span {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    & .circle {
                        width: 10px;
                        height: 10px;
                        border-radius: 50%;
                        &.revenue {
                            background: #B8E6FF;
                        }
                        &.plan {
                            background: #F2B20E;
                        }
                    }
                }
            }
        }
    }
}
</style>
